const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjects(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M41.996 434.78V158.438c0-11.966 9.701-21.667 21.667-21.667H173.33M339.128 136.771h109.209c11.966 0 21.667 9.701 21.667 21.667v274.581M234.651 438.332H24.429c-7.416 0-13.429 6.012-13.429 13.429v5.137C11 481.254 30.746 501 55.103 501h401.794C481.254 501 501 481.254 501 456.897v-5.137c0-7.416-6.012-13.429-13.429-13.429H276.486",
    style: {
      strokeWidth: 22,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#112d55",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.219 351.555c14.193 18.412 13.747 44.676-1.897 62.652L256 457.091l-37.322-42.884c-15.685-18.022-16.093-44.375-1.787-62.794",
    style: {
      strokeWidth: 22,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#0e9941",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#33cccc",
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 187.2,
    r: 42.333,
    style: {
      strokeWidth: 22,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#0e9941",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#33cccc",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m170.142 305.09-53.443 40.922v-76.195a57.38 57.38 0 0 1 29.058-49.902l13.217-7.501M341.858 305.09l53.443 40.922v-76.195a57.38 57.38 0 0 0-29.058-49.902l-13.217-7.501M315.349 307.404V341.7a8.75 8.75 0 0 1-8.75 8.75H205.402a8.75 8.75 0 0 1-8.75-8.75v-34.956",
    style: {
      strokeWidth: 22,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#112d55",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 11h0c-80.223 66.286-110.24 179.774-85.858 294.09h171.716C366.24 190.774 336.223 77.286 256 11z",
    style: {
      strokeWidth: 22,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#112d55",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1,
    className: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjects);
export default __webpack_public_path__ + "static/media/projects.9f90ff92efa19780427dfd4c42f7b767.svg";
export { ForwardRef as ReactComponent };